import React from "reactn";
import SectionThree from "./forms/SectionThree";
import "../../../assets/css/componentSpecificCss/eventListings.css";

class CreateTicket extends React.Component {
  render() {
    return (
      <div className="cont boxes-row mt-50px center-box">
        <SectionThree
          match={this.props.match}
          vals={this.global.myApplicationProfileInfo}
          birthdayParty={this.props.birthdayParty}
        />
      </div>
    );
  }
}

export default CreateTicket;
